export const loobackApiUrl = "https://wh.rsgideon.com/api";
export const apiUrl = "https://api-wh.rsgideon.com";
